<template>
  <div
    data-gp-component="page-header-actions"
    :class="['flex items-center gap-3', alignmentClass]"
  >
    <template v-for="action in visibleActions">
      <vx-tooltip
        v-if="action.tooltip"
        :key="`tt-${action.id}`"
        :text="action.tooltip"
        position="bottom"
      >
        <!-- Tooltip expects a single child element -->
        <span class="inline-flex">
          <vs-button
            v-bind="buttonPropsFor(action)"
            :data-gp-action-id="action.id"
            :disabled="!!action.disabled"
            @click="emitAction(action)"
          >
            <template v-if="action.kind === 'text'">
              {{ action.label }}
            </template>
          </vs-button>
        </span>
      </vx-tooltip>

      <vs-button
        v-else
        :key="action.id"
        v-bind="buttonPropsFor(action)"
        :data-gp-action-id="action.id"
        :disabled="!!action.disabled"
        @click="emitAction(action)"
      >
        <template v-if="action.kind === 'text'">
          {{ action.label }}
        </template>
      </vs-button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageHeaderActions',
  components: {
    VxTooltip: () => import('@/layouts/components/vx-tooltip/VxTooltip.vue'),
  },
  props: {
    actions: {
      type: Array,
      required: true,
    },
    align: {
      type: String,
      default: 'end',
      validator(val) {
        return ['start', 'end'].includes(val);
      },
    },
    size: {
      type: String,
      default: 'large',
      validator(val) {
        return ['small', 'large'].includes(val);
      },
    },
  },
  computed: {
    visibleActions() {
      return (this.actions || []).filter((a) => a && !a.hidden);
    },
    alignmentClass() {
      return this.align === 'start' ? 'justify-start' : 'justify-end';
    },
    iconButtonSize() {
      return this.size === 'small' ? 'small' : 'large';
    },
  },
  methods: {
    emitAction(action) {
      if (!action || action.disabled) return;
      this.$emit('action', { id: action.id });

      // Vuesax can keep a "pressed" background while the button remains focused after click.
      // Blur the active element so the button returns to its normal state immediately.
      this.$nextTick(() => {
        if (typeof document === 'undefined') return;
        const el = document.activeElement;
        if (el && el !== document.body && typeof el.blur === 'function') {
          el.blur();
        }
      });
    },
    buttonPropsFor(action) {
      const kind = action.kind || 'icon';

      const baseProps = kind === 'icon'
        ? {
          radius: true,
          size: this.iconButtonSize,
          color: 'primary',
          type: 'flat',
        }
        : {
          size: 'small',
          color: 'primary',
        };

      const iconProps = action.icon
        ? {
          icon: action.icon,
          'icon-pack': 'feather',
        }
        : {};

      const merged = {
        ...baseProps,
        ...iconProps,
        ...(action.buttonProps || {}),
      };

      // If an icon is set via buttonProps, ensure icon-pack defaults to feather.
      if (merged.icon && !merged['icon-pack']) {
        merged['icon-pack'] = 'feather';
      }

      return merged;
    },
  },
};
</script>


